import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-app-project-calender',
  templateUrl: './app-project-calender.component.html',
  styleUrls: ['./app-project-calender.component.scss']
})
export class AppProjectCalenderComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }

}
